module.exports = __webpack_public_path__ + "assets/img/box_3.69417048.png";